import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Nav,
    NavbarBrand,
    NavbarToggler,
    NavItem,
    NavLink,
} from 'reactstrap';
import HeaderDropdown from './HeaderDropdown';

class Header extends Component {

    constructor(props) {
        super(props);
    }

    sidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-hidden');
    }

    sidebarMinimize(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-minimized');
    }

    mobileSidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-mobile-show');
    }

    //asideToggle(e) {
    //    e.preventDefault();
    //    document.body.classList.toggle('aside-menu-hidden');
    //}

    render() {
        const text = <span>Title</span>;
        const stylePopover = { width: 250 };
        const { accountId, logo, username } = this.props
        console.log(accountId, logo, username)
        return (
            <header className="app-header navbar">
                <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
                    <span className="navbar-toggler-icon"></span>
                </NavbarToggler>
                <NavbarBrand href="#"></NavbarBrand>
                <NavbarToggler className="d-md-down-none" onClick={this.sidebarToggle}>
                    <span className="navbar-toggler-icon"></span>
                </NavbarToggler>



                <Nav className="ml-auto" navbar >
                    <HeaderDropdown {...this.props} username={username} accnt />
                </Nav>


                {
                    //<Nav className="ml-auto" navbar onClick={this.asideToggle}>
                    //    <HeaderDropdown accnt />
                    //</Nav>
                }
            </header>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js